import apiClient from './api-client';
import { API_ENDPOINTS } from '../../constants/api.constants';
import { ReadingSessionSummary } from '../../types/reading-session.types';

export const readingSessionsService = {
  async createReadingSession(data: {
    bookId: string;
    durationSeconds: number;
    startAt?: string;
    endAt?: string;
  }): Promise<void> {
    await apiClient.post(API_ENDPOINTS.READING_SESSIONS, data);
  },

  async getSummary(params?: {
    groupBy?: 'day' | 'week' | 'month' | 'year';
    zone?: string;
    bookId?: string;
    userId?: string;
    limit?: number;
  }): Promise<ReadingSessionSummary> {
    const response = await apiClient.get(API_ENDPOINTS.READING_SESSIONS_SUMMARY, { params });
    return response.data.data;
  },
};
